import { createAction } from 'redux-actions';

// unique key namespace used by combineReducers.
// By convention it will match the directory structure to
// make it easy to locate the src.
// Also action types will prefix with the capitalized version
export const key = 'patientList';

// action creators
export const applyFilter = createAction(`${key}/FILTER_APPLY`,
  (filter) => ({
    filter: filter
  })
);
export const setListLimit = createAction(`${key}/LIST_LIMIT_SET`,
  (limit) => ({
    limit: limit
  })
);

export default {
  setListLimit,
  applyFilter
};



// WEBPACK FOOTER //
// ./src/util/redux/patientList/actions.js